// Settings — signed-in user settings. Kept intentionally simple for go-pim:
// identity + appearance (theme / density). Passkey enrolment (strata's
// PasskeySection) was dropped to shrink scope; the go-pim admin BFF's
// /v1/auth/webauthn/* surface is a later backend step.
import { useAuth } from "@/store/auth";
import { useUI, type Density } from "@/store/ui";
import { Segmented } from "@/components/UI";

const DENSITIES: { value: Density; label: string }[] = [
  { value: "compact", label: "Compact" },
  { value: "regular", label: "Regular" },
  { value: "comfortable", label: "Comfortable" },
];

export function Settings() {
  const user = useAuth((s) => s.user);
  const theme = useUI((s) => s.theme);
  const setTheme = useUI((s) => s.setTheme);
  const density = useUI((s) => s.density);
  const setDensity = useUI((s) => s.setDensity);

  return (
    <div className="page" style={{ padding: 24 }}>
      <header style={{ marginBottom: 16 }}>
        <div className="eyebrow">Settings</div>
        <h1 style={{ fontSize: 28, letterSpacing: "-0.02em", margin: "4px 0" }}>
          Account &amp; preferences
        </h1>
        <p className="dim" style={{ fontSize: 13, maxWidth: 720 }}>
          Your signed-in identity and console appearance.
        </p>
      </header>

      <div className="card" style={{ padding: 16, maxWidth: 560 }}>
        <h3 style={{ marginBottom: 12 }}>Identity</h3>
        <div className="stack-12">
          <div className="row" style={{ justifyContent: "space-between" }}>
            <span className="dim">Email</span>
            <span className="mono">{user?.email ?? "—"}</span>
          </div>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <span className="dim">Role</span>
            <span className="mono">{user?.role ?? "—"}</span>
          </div>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <span className="dim">User ID</span>
            <span className="mono">{user?.user_id ?? "—"}</span>
          </div>
        </div>
      </div>

      <div
        className="card"
        style={{ padding: 16, maxWidth: 560, marginTop: "var(--card-gap, 16px)" }}
      >
        <h3 style={{ marginBottom: 12 }}>Appearance</h3>
        <div className="stack-16">
          <div className="field">
            <label className="label">Theme</label>
            <Segmented<"light" | "dark">
              value={theme}
              onChange={setTheme}
              label="Theme"
              options={[
                { value: "light", label: "Light" },
                { value: "dark", label: "Dark" },
              ]}
            />
          </div>
          <div className="field">
            <label className="label">Density</label>
            <Segmented<Density>
              value={density}
              onChange={setDensity}
              label="Density"
              options={DENSITIES}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
